import React, { useState } from "react";
import "./MessageScreenHeader.css";
import { chatSelector, globalStateSelector } from "../../../../../store/selector";
import { connect } from "react-redux";
import Typography from "../Typography";
import { RenderInitials } from "../Avatar";
import { chatAction, messageAction } from "../../../../../store/action";
import { getUUID } from "../../utils";
import { Alert } from "modules/theme";
import { Modal } from "react-bootstrap";
import SummarySectionComponent from "../../../../theme/theme1/common/components/SummarySectionComponent";
import { CommonFilter, Button, Tip, Spinner, confirm } from "modules/theme";

function MessageScreenHeader({ dynamicUpdate, ...props }) {
  const {
    configProcessor,
    selectedAssignedList,
    showCustomerInfo,
    unAssignedList,
    solveLoading,
    doneLoading,
    isConnected,
    isOffline,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const resolve = () => {
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: "event",
      "rmq:pattern": "agent:event",
      eventMessage: {
        ...(selectedAssignedList && selectedAssignedList.eventMessage),
        from: "agent",
        type: "resolve",
      },
    });
  };


  const openModal = () => {
    setShowModal(true);
    // configProcessor("sendPayload", {
    //   ...selectedAssignedList,
    //   payloadType: "event",
    //   "rmq:pattern": "chat:analytics",
    //   eventMessage: {
    //     ...(selectedAssignedList && selectedAssignedList.eventMessage),
    //     from: "agent",
    //     type: "analytics",
    //   },
    // });
  }

  const handleAnalyticsGeneration = () => {
    dynamicUpdate({ data: { key: `agentSummaryLoading_${selectedAssignedList.sessionId}`, value: true } });
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: "event",
      "rmq:pattern": "global:event",
      eventMessage: {
        ...(selectedAssignedList && selectedAssignedList.eventMessage),
        from: "agent",
        type: "analytics",
      },
    });
  }

  const showInfo = () => {
    dynamicUpdate({ data: { key: "showCustomerInfo", value: true } });
  };
  let isSelectedInUnassigned;
  if (selectedAssignedList && selectedAssignedList.id) {
    isSelectedInUnassigned = unAssignedList.some(
      (item) => item.id === selectedAssignedList.id
    );
  } else {
    // console.error("selectedAssignedList is null or does not have an id.");
  }
  const primaryText =
    selectedAssignedList &&
      selectedAssignedList.customer &&
      selectedAssignedList.customer.display
      ? selectedAssignedList.customer.display
      : "Unknown";
  const platform =
    selectedAssignedList && selectedAssignedList.plateform
      ? selectedAssignedList.plateform
      : "";

  const userDetails = {};
  const longValueDetails = {};

  props.agentSummary
    ? Object.keys(props.agentSummary).forEach((key) => {
      if (key.startsWith("static__")) {
        const newKey = key.replace("static__", ""); // Remove 'static__' prefix
        const value = props.agentSummary[key];

        // Check if value is long
        if (typeof value === "string" && value.length > 15) {
          longValueDetails[newKey] = value; // Store long value
        } else {
          userDetails[newKey] = value; // Store normal value
        }
      }
    })
    : "";

  const renderModal = () => {
    return (
      <Modal
        show={showModal}
        className=""
        bsSize="lg"
      >
        <Modal.Header>
          <Modal.Title>Analytics</Modal.Title>
          <button
            className="material-symbols-outlined bg-white border-none"
            style={{ color: "#010101", fontSize: "25px" }}
            onClick={() => {
              setShowModal(false);
              dynamicUpdate({ data: { key: `agentSummaryLoading_${selectedAssignedList.sessionId}`, value: false } })
            }
            }
          >
            cancel
          </button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div
              className="contact-message-body-item"
              style={{
                height: "calc(100vh - 110px)",
                paddingTop: "0px",
              }}
            >
              {Object.keys(props.agentSummary).length !== 0 ? (
                <div>
                  <div className="d-flex justify-end mt-3 mb-3">
                    <Button
                      className=""
                      type="default"
                      onClick={handleAnalyticsGeneration}
                      disabled={props.agentSummaryLoading}
                    >
                      {props.agentSummaryLoading ? (
                        <Spinner
                          style={{
                            height: "3px",
                            marginTop: "-15px",
                            padding: "10px",
                            marginBottom: "10px",
                          }}
                        />
                      ) : (
                        "Regenrate Analytics"
                      )}
                    </Button>
                  </div>
                  <SummarySectionComponent
                    summary={props.agentSummary}
                    userDetails={userDetails}
                    longValueDetails={longValueDetails}
                  />
                </div>
              ) : (
                <div
                  className="w-100 text-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {!props.agentSummaryLoading ? (
                    <Button
                      className=""
                      type="default"
                      onClick={handleAnalyticsGeneration}
                      disabled={props.agentSummaryLoading}
                    >
                      Generate Analytics
                    </Button>
                  ) : (
                    <div className="loading-content">
                      {/* <img
                        src="/images/icons/loader-alt-alt.gif"
                        alt="stream robot"
                        style={{
                          filter: "invert() hue-rotate(90deg)",
                        }}
                      /> */}
                      <Spinner
                        style={{
                          height: "3px",
                          marginTop: "-15px",
                          padding: "10px",
                          marginBottom: "50px",
                        }}
                      />
                      <div>Please wait</div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <div className={`${props.className}`} {...props}>
      <div className="message-header__left min-w-0 gap-3">
        <button
          className="rounded-circle ratio-1x1 bg-body-secondary p-3 conversation-header__back_button flex align-items-center justify-content-center"
          style={{
            outline: "none",
            // border: "1px solid #d3d3d3",
            border: "none",
          }}
          onClick={(_) => {
            dynamicUpdate({ data: { key: "selectedAssignedList", value: {} } });
          }}
        >
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <div className="position-relative">
          <RenderInitials
            text={primaryText ? primaryText : "Unknown"}
            type={platform}
          />
        </div>
        {/* <Avatar size="lg" imageUrl={"/images/user-img.png"} /> */}
        <div className="d-flex flex-column min-w-0">
          <Typography
            className="main-heading"
            onClick={() => showInfo()}
            variant="primary"
            text={
              (selectedAssignedList &&
                selectedAssignedList.customer &&
                selectedAssignedList.customer.display) ||
              "No name"
            }
          />
          {/* <div
            className="online-sec d-flex align-items-center justify-space-between"
            style={{ gap: "5px" }}
          >
            <span className="green-circle"></span>
            <Typography variant="secondary" text="Online" />
          </div> */}
        </div>
      </div>

      <button
        className="conversation-header__back_button"
        style={{
          outline: "none",
          // border: "1px solid #d3d3d3",
          border: "none",
          background: "transparent",
          paddingTop: '8px'
        }}
        onClick={(_) => {
          // dynamicUpdate({ data: { key: "selectedAssignedList", value: {} } });
          dynamicUpdate({ data: { key: "showCustomerInfo", value: true } });
        }}
      >
        <span className="material-symbols-outlined">info</span>
      </button>
      <div className="message-header_right">
        {isSelectedInUnassigned ? (
          ""
        ) : (
          <div className="d-flex">
            {props.disposeScreen ? "" :
              props.isAnalyticsEnabled || selectedAssignedList.isAnalyticsEnabled ?
                <button className="message-header_right-btn" style={{ marginRight: '10px' }}
                  onClick={() => {
                    // setShowModal(true);
                    openModal();
                  }}
                >
                  <span
                    class="material-symbols-outlined"
                    style={{
                      fontSize: "20px",
                      color: "#0566FF",
                    }}
                  >
                    info
                  </span>
                  {/* <span style={{ marginLeft: '6px' }} className='mobileHideSolve'>Solve</span> */}
                  <span style={{ marginLeft: '6px' }} className='mobileHideSolve'>Analytics</span>
                </button> : ""
            }

            {props.disposeScreen
              ?
              <button className="message-header_right-btn"
                // onClick={resolve}
                // onClick={(e) => {
                //   e.preventDefault();
                //   if (
                //     (props.messageListTag && props.messageListTag.length > 0) &&
                //     (!props.messageFinalTag || (typeof props.messageFinalTag === "object" && Object.keys(props.messageFinalTag).length === 0))
                //   ) {
                //     // Case where messageListTag is not empty, but messageFinalTag is empty
                //     Alert.error("Please select child disposition and press done");
                //     return;
                //   }

                //   // If both messageListTag and messageFinalTag are empty, show error for disposition
                //   if (
                //     (!props.messageListTag || props.messageListTag.length === 0) &&
                //     (!props.messageFinalTag || (typeof props.messageFinalTag === "object" && Object.keys(props.messageFinalTag).length === 0))
                //   ) {
                //     Alert.error("Please select disposition and press done");
                //     return;
                //   }
                //   const messagePayload = {
                //     from: "agent",
                //     timeStamp: new Date().toISOString(),
                //     type: "dispose",
                //     plateform:
                //       selectedAssignedList && selectedAssignedList.plateform
                //         ? selectedAssignedList.plateform
                //         : "",
                //     content: {
                //       comment: props.messageCommentTag,
                //       tag: props.messageFinalTag
                //     },
                //     id: getUUID(),
                //   };
                //   dynamicUpdate({ data: { key: `doneLoading${selectedAssignedList.identifier}`, value: true } });
                //   props.configProcessor("dispose", {
                //     ...selectedAssignedList,
                //     payloadType: "event",
                //     "rmq:pattern": "agent:event",
                //     eventMessage: {
                //       type: 'dispose',
                //       from: 'agent'
                //     },
                //     message: {
                //       ...(selectedAssignedList && selectedAssignedList.message),
                //       ...messagePayload,
                //     },
                //   });
                // }}
                onClick={(e) => {
                  e.preventDefault();

                  if (isOffline || !isConnected) {
                    Alert.error("You are Offline");
                    return;
                  }

                  if (
                    (props.messageListTag && props.messageListTag.length > 0) &&
                    (!props.messageFinalTag || (typeof props.messageFinalTag === "object" && Object.keys(props.messageFinalTag).length === 0))
                  ) {
                    // Case where messageListTag is not empty, but messageFinalTag is empty
                    Alert.error("Please select child disposition and press done");
                    return;
                  }

                  // If both messageListTag and messageFinalTag are empty, show error for disposition
                  if (
                    (!props.messageListTag || props.messageListTag.length === 0) &&
                    (!props.messageFinalTag || (typeof props.messageFinalTag === "object" && Object.keys(props.messageFinalTag).length === 0))
                  ) {
                    Alert.error("Please select disposition and press done");
                    return;
                  }

                  const messagePayload = {
                    from: "agent",
                    timeStamp: new Date().toISOString(),
                    type: "dispose",
                    plateform:
                      selectedAssignedList && selectedAssignedList.plateform
                        ? selectedAssignedList.plateform
                        : "",
                    content: {
                      comment: props.messageCommentTag,
                      tag: props.messageFinalTag
                    },
                    id: getUUID(),
                  };

                  dynamicUpdate({ data: { key: `doneLoading${selectedAssignedList.identifier}`, value: true } });

                  props.configProcessor("dispose", {
                    ...selectedAssignedList,
                    payloadType: "event",
                    "rmq:pattern": "agent:event",
                    eventMessage: {
                      type: 'dispose',
                      from: 'agent'
                    },
                    message: {
                      ...(selectedAssignedList && selectedAssignedList.message),
                      ...messagePayload,
                    },
                  });
                }}
              >
                <span
                  class="material-symbols-outlined"
                  style={{
                    fontSize: "20px",
                    color: "rgb(52, 184, 87)",
                  }}
                >
                  task_alt
                </span>
                {/* <span style={{ marginLeft: '6px' }} className='mobileHideSolve'>Solve</span> */}
                <span style={{ marginLeft: '6px' }} className='mobileHideSolve'>
                  {doneLoading ? (
                    <Spinner
                      style={{
                        height: "3px",
                        marginTop: "-15px",
                        padding: "10px",
                        marginBottom: "10px",
                      }}
                    />
                  ) : (
                    "Done"
                  )}
                </span>
              </button>
              :
              <button className="message-header_right-btn"
                // onClick={resolve}
                onClick={() => {
                  if (isOffline || !isConnected) {
                    Alert.error("You are Offline");
                    return;
                  }

                  confirm("Do you want to solve user?", {
                    url: "/images/icons/accept.png",
                    showConfirmation2: false,
                  }).then((e) => {
                    dynamicUpdate({ data: { key: `solveLoading${selectedAssignedList.identifier}`, value: true } });
                    resolve();
                  });
                  // setDispose(true); // Set dispose to true
                  // setActiveTab("dispose"); // Set active tab to Dispose
                  // configProcessor(`tagList`, { teamId: selectedAssignedList.teamId });
                  // dynamicUpdate({ data: { key: `solveLoading${selectedAssignedList.identifier}`, value: true } });
                  // resolve();
                  // props.setDisposeScreen(true);
                  // props.setActiveTab("dispose");
                }}
              >
                <span
                  class="material-symbols-outlined"
                  style={{
                    fontSize: "20px",
                    color: "rgb(52, 184, 87)",
                  }}
                >
                  task_alt
                </span>
                {/* <span style={{ marginLeft: '6px' }} className='mobileHideSolve'>Solve</span> */}
                <span style={{ marginLeft: '6px' }} className='mobileHideSolve'>
                  {solveLoading ? (
                    <Spinner
                      style={{
                        height: "3px",
                        marginTop: "-15px",
                        padding: "10px",
                        marginBottom: "10px",
                      }}
                    />
                  ) : (
                    "Solve"
                  )}
                </span>
              </button>
            }
          </div>

        )}
      </div>
      {renderModal()}
    </div>
  );
}

const stateToProps = (state) => {
  // Fetch the required state properties first
  const selectedAssignedList = chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  );

  return {
    selectedAssignedList,
    showCustomerInfo: chatSelector.getChatDynamic(state, "showCustomerInfo"),
    unAssignedList: chatSelector.getChatDynamic(state, "unAssignedList"),
    disposeScreen: chatSelector.getChatDynamic(state, "disposeScreen"),
    messageCommentTag: chatSelector.getChatDynamic(state, "messageCommentTag"),
    // messageFinalTag: chatSelector.getChatDynamic(state, `messageFinalTag`),
    messageFinalTag: chatSelector.getChatDynamic(state, `messageFinalTag_${selectedAssignedList.sessionId}`),
    messageListTag: chatSelector.getChatDynamic(state, `messageListTag_${selectedAssignedList.sessionId}`),
    agentSummaryLoading: chatSelector.getChatDynamic(state, `agentSummaryLoading_${selectedAssignedList.sessionId}`),
    // agentSummary: chatSelector.getChatDynamic(state, `agentSummary_${selectedAssignedList.sessionId}` || {}),
    agentSummary: chatSelector.getChatDynamic(
      state,
      `agentSummary_${selectedAssignedList.sessionId}`
    ) || {},
    isAnalyticsEnabled: chatSelector.getChatDynamic(state, `isAnalyticsEnabled_${selectedAssignedList.sessionId}`),
    solveLoading: chatSelector.getChatDynamic(state,
      `solveLoading_${selectedAssignedList.sessionId}`
    ) || false,
    doneLoading: chatSelector.getChatDynamic(state,
      `doneLoading_${selectedAssignedList.sessionId}`
    ) || false,
    isConnected: globalStateSelector.getIsConnected(state),
    isOffline: globalStateSelector.getIsOffline(state),
  };
};

// const stateToProps = (state) => ({

//   const selectedAssignedList = chatSelector.getChatDynamic(
//     state,
//     "selectedAssignedList"
//   );

//   return {
//     selectedAssignedList,
//     showCustomerInfo: chatSelector.getChatDynamic(state, "showCustomerInfo"),
//     unAssignedList: chatSelector.getChatDynamic(state, "unAssignedList"),
//     disposeScreen: chatSelector.getChatDynamic(state, "disposeScreen"),
//     messageCommentTag: chatSelector.getChatDynamic(state, "messageCommentTag"),
//     messageFinalTag: chatSelector.getChatDynamic(state, `messageFinalTag_${selectedAssignedList.sessionId}`),
//   }
//   // selectedAssignedList: chatSelector.getChatDynamic(
//   //   state,
//   //   "selectedAssignedList"
//   // ),

// });
const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },

  setDisposeScreen: (data) => {
    dispatch(chatAction.setDisposeScreen(data));
  },

  setActiveTab: (data) => {
    dispatch(chatAction.setActiveTab(data));
  }
});
export default connect(stateToProps, dispatchToProps)(MessageScreenHeader);
// export default connect(stateToProps)(MessageScreenHeader);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageScreenHeader/MessageScreenHeader.js